// utils/cookieFormatter.js

/**
 * Fonction pour formater les cookies spécifiquement pour le format attendu par ORPI
 * @returns {Array} - Un tableau formaté de cookies pour ORPI
 */
export const formatCookies = () => {
  try {
    // Format exact des cookies pour correspondre au fichier exemple ORPI
    const cookiesData = [
      {
        "domain": ".orpi.com",
        "expirationDate": 1820930800,
        "hostOnly": false,
        "httpOnly": false,
        "name": "_ga",
        "path": "/",
        "sameSite": "unspecified",
        "secure": false,
        "session": false,
        "storeId": "0",
        "value": "GA1.2.812885941.1710325873"
      },
      {
        "domain": ".orpi.com",
        "expirationDate": 1820930800,
        "hostOnly": false,
        "httpOnly": false,
        "name": "_ga_C3MDXG7L67",
        "path": "/",
        "sameSite": "unspecified",
        "secure": false,
        "session": false,
        "storeId": "0",
        "value": "GS1.1.1710346499.2.1.1710347404.60.0.0"
      },
      {
        "domain": ".orpi.com",
        "expirationDate": 1820930800,
        "hostOnly": false,
        "httpOnly": false,
        "name": "_ga_NYTTJ0XZ84",
        "path": "/",
        "sameSite": "unspecified",
        "secure": false,
        "session": false,
        "storeId": "0",
        "value": "GS1.1.1710346495.2.1.1710347404.60.0.0"
      },
      {
        "domain": ".orpi.com",
        "expirationDate": 1820930800,
        "hostOnly": false,
        "httpOnly": false,
        "name": "_gid",
        "path": "/",
        "sameSite": "unspecified",
        "secure": false,
        "session": false,
        "storeId": "0",
        "value": "GA1.2.683363090.1710325873"
      },
      {
        "domain": ".orpi.com",
        "expirationDate": 1710412217,
        "hostOnly": false,
        "httpOnly": false,
        "name": "_gat_gtag_UA_69848154_1",
        "path": "/",
        "sameSite": "unspecified",
        "secure": false,
        "session": false,
        "storeId": "0",
        "value": "1"
      },
      {
        "domain": ".orpi.com",
        "expirationDate": 1710412217,
        "hostOnly": false,
        "httpOnly": false,
        "name": "_gat_UA-69848154-1",
        "path": "/",
        "sameSite": "unspecified",
        "secure": false,
        "session": false,
        "storeId": "0",
        "value": "1"
      },
      {
        "domain": "www.orpi.com",
        "expirationDate": 1710433805,
        "hostOnly": true,
        "httpOnly": false,
        "name": "didomi_token",
        "path": "/",
        "sameSite": "lax",
        "secure": false,
        "session": false,
        "storeId": "0",
        "value": "eyJ1c2VyX2lkIjoiMThkZTFiNzYtMzEwMC02ZTY4LThkYjMtNjAwMDRiNjRhN2RhIiwiY3JlYXRlZCI6IjIwMjMtMDMtMTNUMTY6MTc6NDMuNTAyWiIsInVwZGF0ZWQiOiIyMDIzLTAzLTEzVDE2OjE3OjQzLjUwMloiLCJ2ZW5kb3JzIjp7ImVuYWJsZWQiOlsiZ29vZ2xlIiwiYzpjb25zZW50LW1hbmFnZXItZkJMcHZ4cVEiLCJjOnJldGFyZ2V0aW5nLWJwdkxLNmtTIiwiYzppbnNlZS1kb3VibGVjbGljay14ZkxSeGZHaCIsImM6YXRpbnRlcm5ldC1XeExIaFR5VSIsImM6dHdpdHRlci1hZHMtaXpZSGZoRHkiLCJjOmNyaXRlby1jcml0ZW8tRmV5N3F2eXAiLCJjOmxpbmtlZGluLWluc2lnaHRzLXRhZy1FdlNrdWhwMiIsImM6Y3J5b216LU50YkJXeGZ3IiwiYzpiYXpvb21vcmEtWDdHZndmNUQiLCJjOmdvb2dsZS1hZGRzLW5QdnhSMndHIiwiYzp5YW5kZXgtbWV0cmljYS1IeHBpSmlQWiIsImM6cG9wdXAtVFJ5bW43YnoiLCJjOmdlb2xvY2F0aW9uLW14d3JFV1g1IiwiYzp5YW5kZXgtbWV0cmljYS0ycGZUR3BrZyIsImM6ZGVtYW5kYmFzZS1pcXhrTDhuVSIsImM6ZnVsbHN0b3J5LXJlY29yZGluZy1KdkRWdnRKNiIsImM6b21uaWNvbnZlcnNpb24tSFJVaEVYTkciLCJjOmFtcGxpdHVkZS12dmpNcmlnWiIsImM6aG9sbGlzZXRpYy1pdlJQa0toeSIsImM6Y3JhenktZWdnLXBGTEV4eWdmIiwiYzpqaXZvY2hhdC1NdGpOaFJ1dyIsImM6d2VidGVsbmV0LVZZeFlHV1pKIiwiYzptaWNyb3NvZnQtY2xhcml0eS1ibXdrOW5nSyIsImM6eHRyZW1wdXNoLUU0Rkd4VlNEIiwiYzpmdXNlcGFuZWwtblV4dm1Nckci"
      },
      {
        "domain": "www.orpi.com",
        "expirationDate": 1710433805,
        "hostOnly": true,
        "httpOnly": false,
        "name": "euconsent-v2",
        "path": "/",
        "sameSite": "lax",
        "secure": false,
        "session": false,
        "storeId": "0",
        "value": "CP2cRQAP2cRQAAHABBENC5CsAP_AAH_AAAAAIltf_X__b3_j-_5_f_t0eY1P9_7_v-0zjhfdt-8N3f_X_L8X42M7vF36pq4KuR4Eu3LBIQdlHOHcTUmw6okVrzPsbk2cr7NKJ7PEmnMbO2dYGH9_n93TuZKY7______z_v-v_v____f_7-3_3__5_3---_e_V_99zLv9____39nP___9v-_9_____4IhgEmGpeQBdmWODJtGlUKIEYVhIdAKACigGFoisIHVwU7K4CfUELABCagIwIgQYgoxYBAAIBAEhEQEgB4IBEARAIAAQAqQEIACNgEFgBYGAQACgGhYgRQBCBIQZHBUcpgQFSLRQT2ViCUHexphCGWeBFAo_oqEBGs0QLAyEhYOY4AkBLxZIHmKF8gAAAAA.flgAAAAAAAAA"
      },
      {
        "domain": "www.orpi.com",
        "expirationDate": 1711035805,
        "hostOnly": true,
        "httpOnly": false,
        "name": "Orpi-device-id",
        "path": "/",
        "sameSite": "lax",
        "secure": false,
        "session": false,
        "storeId": "0",
        "value": "3c37a4a3-d87a-4d14-8bfd-c84df6da2b0a"
      },
      {
        "domain": ".orpi.com",
        "hostOnly": false,
        "httpOnly": false,
        "name": "ORPI-lead",
        "path": "/",
        "sameSite": "unspecified",
        "secure": false,
        "session": true,
        "storeId": "0",
        "value": "0"
      },
      {
        "domain": "www.orpi.com",
        "expirationDate": 1711020400,
        "hostOnly": true,
        "httpOnly": false,
        "name": "modal_login_display",
        "path": "/",
        "sameSite": "unspecified",
        "secure": false,
        "session": false,
        "storeId": "0",
        "value": "true"
      },
      {
        "domain": "www.orpi.com",
        "expirationDate": 1718121600,
        "hostOnly": true,
        "httpOnly": false,
        "name": "laravel_session",
        "path": "/",
        "sameSite": "lax",
        "secure": false,
        "session": false,
        "storeId": "0",
        "value": "eyJpdiI6IlVjUXJmOUdteG9hSm9yTnRnZ3Z5ZlE9PSIsInZhbHVlIjoiVkVMMm9NajZvZnFiRTA5ZVBLWFJ1OVN3KzVZS3Y3RWxHMndvN0REcVJ4NFhLbmh1NU9mUVREU2VTQlU3dzR3dThPb1E1OFVYNGRDMmNZVlNEelwvUjJDdERzc1lhdnpNZGZUUDNRYUtnYVZJdUw2a2M2SHgwZTJIdmM4cko1OUMiLCJtYWMiOiI2MTdjMTE1MWYwYzZkZjE3M2M5OWE1NTlkNjgwNmI1MWEyODc0NjI3MGZmNmJhNWUwZWVlYTg2YjNkN2RjODlkIn0%3D"
      },
      {
        "domain": "www.orpi.com",
        "expirationDate": 1718121600,
        "hostOnly": true,
        "httpOnly": false,
        "name": "XSRF-TOKEN",
        "path": "/",
        "sameSite": "unspecified",
        "secure": false,
        "session": false,
        "storeId": "0",
        "value": "eyJpdiI6IlQ4ZFhid0dlQm03UUNHZFFcL0tzZDN3PT0iLCJ2YWx1ZSI6Ink3VmNsYkhuRVhyRnlnTUlBVzZtUmtjZnRFWSt3UFRmUHdwaGhyQWt1MGJZZTVPZ1hwa2VWcURzNnN0anZsXC9NNG14eExHVFE2YmxBVU9HMnRtaXRxdz09IiwibWFjIjoiNmViMDdmNTM5MWU2Zjc0YzQ1NDViYmUxYTBmYzM0NzU2ODNkMzc5Y2FjZTk5MTExOWVmYTY5OWIzNzUzZDYzZSJ9"
      }
    ];
    
    // Ajouter éventuellement des valeurs dynamiques
    const now = new Date();
    const timestamp = Math.floor(now.getTime() / 1000);
    const deviceId = generateRandomId();
    
    // Mettre à jour les timestamps si nécessaire
    cookiesData.forEach(cookie => {
      // Ne pas modifier les expirations existantes, seulement dans le cas
      // où on voudrait des cookies plus "frais" pour ORPI
      
      // Exemple si besoin:
      // if (cookie.name === "Orpi-device-id") {
      //   cookie.value = deviceId;
      // }
    });
    
    return cookiesData;
  } catch (error) {
    console.error('Erreur lors de la récupération des cookies:', error);
    return [];
  }
};

// Fonction utilitaire pour générer un ID aléatoire
function generateRandomId() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}